module.exports = __webpack_public_path__ + "img/securitydetailsLogo3.0b845101.png";